module.exports = "../study/imgs/maps/Kanagawa/S8/Helth/HeatStress/Kanagawa_HeatStress_MIROC5_RCP26_Now.png";